/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'company-hub.section-extension.config-panel.background-color-field.background-color': 'Background colour',
  'company-hub.section-extension.config-panel.content-width-field.full-label': 'Full',
  'company-hub.section-extension.config-panel.content-width-field.full-tooltip': 'Full width',
  'company-hub.section-extension.config-panel.content-width-field.label': 'Content width',
  'company-hub.section-extension.config-panel.content-width-field.narrow-label': 'Narrow',
  'company-hub.section-extension.config-panel.content-width-field.narrow-tooltip': 'Narrow',
  'company-hub.section-extension.config-panel.content-width-field.wide-label': 'Wide',
  'company-hub.section-extension.config-panel.content-width-field.wide-tooltip': 'Wide',
  'company-hub.section-extension.config-panel.preamble': 'Organise elements into customisable sections. {supportLink}',
  'company-hub.section-extension.config-panel.preamble-link.label': 'Learn more about designing your hub.',
  'company-hub.section-extension.config-panel.preamble-without-support-link':
    'Organise related elements into sections with customisable backgrounds and styling.',
  'company-hub.section-extension.config-panel.title': 'Section',
  'company-hub.section-extension.error-loading-content': 'Error loading content',
  'company-hub.section-extension.manifest.content.header': 'Give your section a title',
  'company-hub.section-extension.manifest.content.placeholder-title': 'Placeholder',
  'company-hub.section-extension.manifest.content.sub-header':
    'Organise elements into sections with customisable backgrounds.',
  'company-hub.section-extension.manifest.extension-lozenge-title': 'Section',
  'company-hub.section-extension.manifest.extension-title': 'Section [New]',
  'company-hub.section-extension.manifest.macro-description': 'Group elements together with a background',
};
